<template>
  <div>

    <section class="home-slider owl-carousel align-self-center">
      <div class="slider-item" style="background-image: url('/assets/img/banner/01.jpg');"></div>
      <div class="slider-item" style="background-image: url('/assets/img/banner/02.jpg');"></div>
      <div class="slider-item" style="background-image: url('/assets/img/banner/03.jpg');"></div>
      <div class="slider-item" style="background-image: url('/assets/img/banner/04.jpg');"></div>


    </section>

    <section class="section">
      <div class="container">

        <div class="row justify-content-center mb-5 ">
          <div class="col-md-8 text-center">
            <h2 class="text-uppercase heading border-bottom mb-4">خدماتنا</h2>
          </div>
        </div>

        <div class="row justify-content-center mb-5">

          <div class="col-lg-4 col-md-4 col-12 mb-3 ">
            <div class="media d-block media-feature text-center">
              <span class="flaticon-crane icon"></span>
              <div class="media-body">
                <h3 class="mt-0 text-black">انشاءات</h3>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 mb-3 ">
            <div class="media d-block media-feature text-center">
              <span class="flaticon-helmet icon"></span>
              <div class="media-body">
                <h3 class="mt-0 text-black">مشاريع صغيره</h3>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 mb-3 ">
            <div class="media d-block media-feature text-center">
              <span class="flaticon-blueprint icon"></span>
              <div class="media-body">
                <h3 class="mt-0 text-black">تصميم</h3>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-4 col-12 mb-3 ">
            <div class="media d-block media-feature text-center">
              <span class="flaticon-building-1 icon"></span>
              <div class="media-body">
                <h3 class="mt-0 text-black">مشاريع كبيره</h3>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 mb-3 ">
            <div class="media d-block media-feature text-center">
              <span class="flaticon-building icon"></span>
              <div class="media-body">
                <h3 class="mt-0 text-black">مشاريع ضخمه</h3>
              </div>
            </div>
          </div>


        </div>
        <!-- END row -->
      </div>
    </section>
    <!-- END section -->

    <section class="section border-t">
      <div class="container">
        <div class="row justify-content-center mb-5 ">
          <div class="col-md-8 text-center">
            <h2 class="text-uppercase heading border-bottom mb-4">اعمالنا</h2>
          </div>
        </div>

        <div class="row no-gutters">
          <div class="col-md-4 ">
            <a href="#" class="link-thumbnail">
              <h3>مبني الطلاب بجامعه قناه السويس الجديدة</h3>
              <span class="ion-plus icon"></span>
              <img src="/assets/img/works/01.jpg" alt="Image placeholder" class="img-fluid">
            </a>
          </div><div class="col-md-4 ">
          <a href="#" class="link-thumbnail">
            <h3>#</h3>
            <span class="ion-plus icon"></span>
            <img src="/assets/img/works/02.jpg" alt="Image placeholder" class="img-fluid">
          </a>
        </div><div class="col-md-4 ">
          <a href="#" class="link-thumbnail">
            <h3>#</h3>
            <span class="ion-plus icon"></span>
            <img src="/assets/img/works/03.jpg" alt="Image placeholder" class="img-fluid">
          </a>
        </div><div class="col-md-4 ">
          <a href="#" class="link-thumbnail">
            <h3>#</h3>
            <span class="ion-plus icon"></span>
            <img src="/assets/img/works/04.jpg" alt="Image placeholder" class="img-fluid">
          </a>
        </div><div class="col-md-4 ">
          <a href="#" class="link-thumbnail">
            <h3>#</h3>
            <span class="ion-plus icon"></span>
            <img src="/assets/img/works/05.jpg" alt="Image placeholder" class="img-fluid">
          </a>
        </div><div class="col-md-4 ">
          <a href="#" class="link-thumbnail">
            <h3>مسجد قناه السويس الجديده</h3>
            <span class="ion-plus icon"></span>
            <img src="/assets/img/works/06.jpg" alt="Image placeholder" class="img-fluid">
          </a>
        </div>

        </div>
      </div>
    </section>
    <!-- END section -->

    <section class="section bg-light">
      <div class="container">
        <div class="row justify-content-center ">
          <div class="col-md-8 text-center ">
            <h2 class="text-uppercase heading border-bottom mb-4">التأسيس</h2>
            <p class="mb-0 lead">أسسها المهندس محمد الديب الحاصل علي
              بكالوريوس الهندسه المدنيه عام 1990، وماجستير في اداره المشروعات . بدأت الشركه في مجال الانشاءات والمقاولات
              فعليا داخل جمهوريه مصر العربيه في عام 1995</p>
          </div>
        </div>
      </div>
    </section>
    <!-- END section -->

    <section class="section">
      <div class="container">
        <div class="row justify-content-center mb-5 ">
          <div class="col-md-8 text-center mb-5">
            <h2 class="text-uppercase heading border-bottom mb-4">شركاء النجاح</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2 col-4 ">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/partners/01.jpg" alt="Image placeholder" class="img-fluid mb-3">
            </div>
          </div>
          <div class="col-md-2 col-4 ">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/partners/02.jpg" alt="Image placeholder" class="img-fluid mb-3">
            </div>
          </div>
          <div class="col-md-2 col-4 ">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/partners/03.jpg" alt="Image placeholder" class="img-fluid mb-3">
            </div>
          </div>

          <div class="col-md-2 col-4 ">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/partners/04.png" alt="Image placeholder" class="img-fluid mb-3">
            </div>
          </div>
          <div class="col-md-2 col-4 ">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/partners/05.png" alt="Image placeholder" class="img-fluid mb-3">
            </div>
          </div>
          <div class="col-md-2 col-4 ">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/partners/06.jpg" alt="Image placeholder" class="img-fluid mb-3">
            </div>
          </div>

        </div>
      </div>
    </section>


  </div>
</template>

<script>
export default {
  name: "Home",
  mounted() {
    // home slider
    $('.home-slider').owlCarousel({
      loop:true,
      autoplay: true,
      margin:10,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      nav:true,
      autoplayHoverPause: true,
      items: 1,
      navText : ["<span class='ion-chevron-left'></span>","<span class='ion-chevron-right'></span>"],
    });
  }
}
</script>

<style scoped>
.owl-carousel{
  width: 80%!important;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 20px;
}

.slider-item{
  min-height: 500px!important;
  height: 500px!important;
}
</style>